<template>
  <div class="page-wrap"
      :style="isPC
      ? 'padding: 1.375rem 2.5vw 1.5rem; overflow-x: hidden'
      : 'padding: 3.375rem 2.5vw 1.5rem; overflow-x: hidden'
    "
  >
    <div class="gacha-container">
      <div v-if="loading" class="loading-mask">
        <div class="loading-box">{{ $t('collection.loadingTip') }}</div>
      </div>
      <div v-else>
        <el-button class="lucky-gacha-btn" @click="onGacha" type="warning" plain round >🎴 {{ $t('gacha.luckyGacha') }}</el-button>
        <el-button class="lucky-gacha-btn active" @click="onMyGacha" type="warning" plain round>📦 {{ $t('collection.myCollection') }}</el-button>
        <el-button class="lucky-gacha-btn" @click="onCardShop" type="warning" plain round>🏪 {{ $t('gacha.cardShop') }}</el-button>
        <div class="filter-row">
          <div class="coin-group">
            <svg width="36" height="36" viewBox="-2 -2 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g>
                <circle cx="12" cy="12" r="11" fill="#F59E0B" stroke="#D97706" stroke-width="1.5" />
                <circle cx="12" cy="12" r="8" fill="#FCD34D" opacity="0.5" />
                <text x="12" y="16" text-anchor="middle" font-size="9" font-weight="800" fill="#92400E" font-family="Nunito,sans-serif">M</text>

                <animateTransform
                    attributeName="transform"
                    type="translate"
                    values="0 0; 0 -2; 0 0"
                    keyTimes="0; 0.5; 1"
                    dur="0.6s"
                    repeatCount="indefinite" />
              </g>
            </svg>
            <div class="coin-stat">
              <div class="stat-title text-xs text-gray-500 font-medium">{{ $t('studentProgramme.coinBalance') }}</div>
              <div class="stat-num shimmer-gold">{{ Number(userCardsRoleNum).toLocaleString() }}</div>
            </div>
          </div>
        </div>
        <div class="filter-row">
          <div class="filter-group">
            <el-button style="color: white;background: rgb(28, 26, 46);border: rgb(28, 26, 46);font-family: Nunito;"
                       class="glow-btn card-rate card-tag"
                       size="mini"
                       plain
                       round
                       type="warning"
                       @click="propertyId=null;getCardsUser()">
              {{ $t('collection.allProperty') }}
            </el-button>
            <el-button
               v-for="item in propertys"
               :key="item.id"
               plain
               round
               :class="`tag-${item.id}`"
               type="warning"
               @click="goGetMyCardsByProperty(item.id)"
               size="mini"
            >
              {{ item.name }}
            </el-button>
          </div>
          <!-- 分隔線 你指定的顏色 -->
          <div style="width:100%; height:1px; background: rgb(254, 243, 199); margin:10px 0;"></div>
          <div class="filter-group">
            <el-button style="color: white;background: rgb(28, 26, 46);border: rgb(28, 26, 46);font-family: Nunito;"
                       class="glow-btn card-rate card-tag"
                       size="mini"
                       plain
                       round
                       type="warning"
                       @click="titleId=null;getCardsUser()">
              {{ $t('collection.allSeries') }}
            </el-button>
            <el-button
                v-for="item in titles"
                :key="item.id"
                plain
                round
                :class="`tag-${item.id}`"
                type="warning"
                @click="goGetMyCardsByTitle(item.id)"
                size="mini"
            >
              {{ studying==0?item.name:item.enName }}
            </el-button>
          </div>
        </div>
        <el-empty v-if="total==0" :image-size="200"></el-empty>
        <div class="content-box">
          <div class="card-grid">
            <div
                class="card-item"
                @click="showCardImage(index)"
                :class="[
      { active: activeIndex === index },
      item.userCardCount > 0 ? `title-glow-${item.propertyId}` : ''
    ]"
                v-for="(item, index) in cardList"
                :key="item.id"
            >
              <img v-if="item.userCardCount>0" class="card-img" :src="item.image" alt="" />
              <img v-if="item.userCardCount==0" class="card-img" :src="require('@/assets/images/noka.png')" alt="" />
              <div class="card-overlay" />
              <div class="card-info">
<!--                <div class="card-name">{{ item.cardName }}</div>-->
                <div class="card-tags">
<!--                  <span class="tag" :class="`tag-${item.propertyId}`">{{ studying==0?item.titleName:item.titleEnName }}</span>-->
                  <span class="tag" :class="`tag-${item.propertyId}`">{{ item.propertyName }}</span>
                  <span class="tag" :class="`tag-${item.propertyId}`">{{ $t('collection.holdCount') }}{{ item.userCardCount }}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- 分页控件 -->
          <div class="pagination-container" v-if="total > 0">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="listQ._page2"
                :page-sizes="[12, 24, 36, 48]"
                :page-size="listQ._limit"
                layout="prev, pager, next"
                :total="total"
            />
          </div>

        </div>
      </div>
      <div class="modal-mask" v-show="showCardModal" @click.self="showCardModal=false">
        <div class="modal-content">
<!--          <div class="modal-close-x" @click="showCardModal=false">×</div>-->
          <!-- 增加动态class绑定系列发光 -->
          <div class="card-img-wrap" :class="`title-glow-${cardPreviewPropertyId}`"
               v-if="userCardCount>0">
            <img
                v-if="userCardCount>0"
                class="modal-image"
                :src="cardPreviewImage"
                alt=""
            />
          </div>
          <img
              v-if="userCardCount==0"
              class="modal-image"
              :src="require('@/assets/images/noka.png')"
              alt=""
          />

<!--          <div class="modal-name">{{ cardPreviewName }}</div>-->
<!--          <div class="modal-attrs">-->
<!--            <span class="tag" :class="`tag-${cardPreviewPropertyId}`">{{ studying==0?cardPreviewTitleName:cardPreviewTitleEnName }}</span>-->
<!--            <span class="tag" :class="`tag-${cardPreviewPropertyId}`">{{ cardPreviewPropertyName }}</span>-->
<!--            <span class="tag" :class="`tag-${cardPreviewPropertyId}`">{{ $t('collection.holdCount') }}{{ userCardCount }}</span>-->
<!--          </div>-->
<!--          <div class="modal-content-text">{{ cardPreviewContent }}</div>-->
          <button
              style="width: 100%;margin-top: 10px;"
              class="table-button"
              @click="showCardModal=false;unlockBodyScroll()"
          >
            {{ $t('studentProgramme.later') }}
          </button>
        </div>
      </div>

    </div>
  </div>

</template>

<script>
import { getCardsUser, indexTitle, indexProperty,getUserCardsRoleNum } from "@/api/cards";
import {getStudying} from "@/api/user";
import {isPC} from "@/utils/is-rules";

export default {
  data() {
    return {
      isPC: isPC(),
      loading: true,
      userCardsRoleNum: 0,
      activeIndex: -1,
      showCardModal: false,
      cardPreviewImage: "",
      cardPreviewName: "",
      cardPreviewPropertyName: "",
      userCardCount: 0,
      cardPreviewPropertyId: "",
      cardPreviewTitleId: "",
      cardPreviewContent: "",
      cardPreviewTitleName: "",
      cardPreviewTitleEnName: "",
      cardList: [],
      titles: [],
      propertys: [],
      total: 0,
      studying: 0,
      titleName:'',
      titleId: null,
      propertyId: null,
      listQ: {
        _page2: 1,    // 当前页码
        _limit: 12    // 每页数量
      },
    };
  },
  created() {
    this.getUserCardsRoleNum();
    this.getStudying();
    this.indexTitle();
    this.indexProperty();
    this.getCardsUser();
  },
  methods: {
    onGacha() {
      const newPath = "/gacha";
      const currentPath = this.$route.path;
      if (currentPath !== newPath) {
        this.$router.push({ path: newPath });
      }
    },
    onMyGacha() {
      const newPath = "/myGacha";
      const currentPath = this.$route.path;
      if (currentPath !== newPath) {
        this.$router.push({ path: newPath });
      }
    },
    onCardShop() {
      const newPath = "/cardShop";
      const currentPath = this.$route.path;
      if (currentPath !== newPath) {
        this.$router.push({ path: newPath });
      }
    },
    async getUserCardsRoleNum() {
      const res = await getUserCardsRoleNum();
      this.userCardsRoleNum = res.data;
    },
    handleDropdownCommand(item) {
      if(item === 'all') {
        this.titleId = null;
        this.getCardsUser();
        this.titleName=this.$t("collection.allSeries");
      } else {
        this.goGetMyCards(item.id)
        this.titleName=this.studying==0?item.name:item.enName;
      }
    },
    async getStudying() {
      const v = await getStudying();
      this.studying = v.data;
    },
    // 切换系列 → 重置到第1页
    goGetMyCards(id) {
      this.titleId = id;
      this.listQ._page2 = 1;
      this.getCardsUser();
    },
    // 切换属性 → 重置到第1页
    goGetMyCardsByProperty(id) {
      this.propertyId = id;
      this.listQ._page2 = 1;
      this.getCardsUser();
    },
    goGetMyCardsByTitle(id) {
      this.titleId = id;
      this.listQ._page2 = 1;
      this.getCardsUser();
    },
    indexTitle() {
      indexTitle().then((v) => {
        this.titles = v.data;
      });
    },
    indexProperty() {
      indexProperty().then((v) => {
        this.propertys = v.data;
      });
    },
    // 获取我的卡片（带分页）
    getCardsUser() {
      this.getUserCardsRoleNum();
      let form = {
        titleId: this.titleId,
        propertyId: this.propertyId,
        _page: this.listQ._page2 - 1,  // 后端从0开始
        _limit: this.listQ._limit,
      };
      getCardsUser(form).then((v) => {
        this.cardList = v.data;
        this.total = Number(v.headers["x-total-count"] || 0);
        this.loading = false;
      });
    },
    // 每页条数改变
    handleSizeChange(val) {
      this.listQ._limit = val;
      this.getCardsUser();
    },
    // 当前页码改变
    handleCurrentChange(val) {
      this.listQ._page2 = val;
      this.getCardsUser();
    },
    unlockBodyScroll() {
      document.documentElement.classList.remove('modal-open');
      document.body.classList.remove('modal-open');
    },
    showCardImage(index) {
      this.activeIndex = index;
      const item = this.cardList[index];
      this.cardPreviewName = item.cardName;
      this.cardPreviewImage = item.image;
      this.cardPreviewPropertyName = item.propertyName;
      this.userCardCount = item.userCardCount;
      this.cardPreviewPropertyId = item.propertyId;
      this.cardPreviewTitleId = item.titleId;
      this.cardPreviewContent = item.content;
      this.cardPreviewTitleName = item.titleName;
      this.cardPreviewTitleEnName = item.titleEnName;
      this.showCardModal = true;
    },
  },
};
</script>

<style scoped>
:root {
  background: #0d0d13;
  min-height: 100vh;
}

.gacha-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 2.5rem;
  width: 100%;
  padding: 0 10px;
  box-sizing: border-box;
}

.loading-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.loading-box {
  background: #fff;
  padding: 25px 40px;
  border-radius: 12px;
  font-size: 16px;
  color: #333;
}

.top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
  position: relative;
  z-index: 1001 !important;
}
.left-empty {
  flex: 1;
  text-align: left;
}
.right-empty {
  flex: 1;
  text-align: right;
}
.title {
  flex: 2;
  text-align: center;
  color: #fff;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 3rem;
  font-weight: 700;
  font-family: "GenSenRoundedTW", "Helvetica", "Arial";
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.8);
}

.filter-row {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding: 12px 16px;
  /* 深色半透明，适配深色背景 */
  background: rgba(251, 251, 252, 1);
  border-radius: 16px;
  flex-wrap: wrap; /* 核心：手机自动换行 */
  width: 100%;
  box-sizing: border-box;
  margin-top: 10px;border: 1px solid rgb(253, 230, 138);
}
/* 第二個 filter-group 強制換行 */
.filter-group:nth-child(2) {
  width: 100%;
  margin-top: 8px;
}
.filter-group {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

:deep(.glow-btn) {
  position: relative;
  border-radius: 10px !important;
  padding: 6px 14px !important;
  font-weight: 600 !important;
  border: none !important;
  color: #fff !important;
  background: rgba(255, 255, 255, 0.06) !important;
  transition: all 0.3s ease !important;
  overflow: hidden;
}
:deep(.glow-btn:hover) {
  transform: translateY(-2px) !important;
  background: rgba(136, 96, 255, 0.25) !important;
  box-shadow: 0 0 12px rgba(136, 96, 255, 0.4) !important;
}
:deep(.glow-btn.is-active) {
  background: linear-gradient(90deg, #7c4dff, #b26eff) !important;
  box-shadow: 0 0 18px rgba(124, 77, 255, 0.6) !important;
  color: #fff !important;
  font-weight: bold !important;
}
:deep(.glow-btn:active) {
  transform: translateY(0px) !important;
}

.card-grid {
  display: grid;
  /*grid-template-columns: repeat(4, 260px);*/
  /*grid-auto-rows: 365px;*/
  grid-template-columns: repeat(5, 197px);
  grid-auto-rows: 274px;
  gap: 20px;
  justify-content: center;
}
.card-item {
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  box-shadow: 0 8px 24px rgba(0,0,0,0.6);
}
.card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.card-overlay {
  position: absolute;
  inset: 0;
  z-index: 1;
}
.card-info {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 18px 14px;
  z-index: 2;
  text-align: left;
}
.card-name {
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  margin-bottom: 8px;
  text-shadow: 0 2px 8px #444;
}
.card-tags {
  display: flex;
  gap: 6px;
}

/* 标签样式（卡片 + 弹窗共用） */
.tag {
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 999px;
  font-weight: bold;
  color: #fff;
  background-size: 200% 200%;
  animation: tagGlow 3s linear infinite;
}
@keyframes tagGlow {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}
/*1:淺天藍 2:香芋紫 3:金黃 4:活力橙 5:蜜桃粉*/
/*6:薄荷綠 7:草莓紅 8:青湖藍 9:夢幻紫 10:嫩草綠*/
.tag-1 { background: #ffffff;color: #4ade80;border: 2px solid rgba(74, 222, 128, 0.33); }
.tag-2 { background: #ffffff;color: #a78bfa;border: 2px solid rgba(167, 139, 250, 0.33); }
.tag-3 { background: #ffffff;color: #facc15;border: 2px solid rgba(250, 204, 21, 0.33); }
.tag-4 { background: #ffffff;color: #fb923c;border: 2px solid rgba(251, 146, 60, 0.33); }
.tag-5 { background: #ffffff;color: #f472b6;border: 2px solid rgba(244, 114, 182, 0.33); }
.tag-6 { background: #ffffff;color: #34d399;border: 2px solid rgba(52, 211, 153, 0.33); }
.tag-7 { background: #ffffff;color: #f87171;border: 2px solid rgba(248, 113, 113, 0.33); }
.tag-8 { background: #ffffff;color: #22d3ee;border: 2px solid rgba(34, 211, 238, 0.33); }
.tag-9 { background: #ffffff;color: #c084fc;border: 2px solid rgba(192, 132, 252, 0.33); }
.tag-10 { background: #ffffff;color: #7dd3fc;border: 2px solid rgba(125, 211, 252, 0.33); }
/* 卡片边框稀有度 */
.rarity-1 { border: 4px solid #999; }
.rarity-2 { border: 4px solid #6fb7ff; }
.rarity-3 { border: 4px solid #4d9dff; }
.rarity-4 { border: 4px solid #9370db; }
.rarity-5 { border: 4px solid #ffd700; }

.card-item:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 16px 40px rgba(0,0,0,0.6);
}

/* 分页样式 */
.pagination-container {
  display: flex;
  justify-content: center;
  margin-top: 40px;
}
:deep(.el-pagination) {
  --el-pagination-bg-color: transparent;
  --el-pagination-text-color: #fff;
  --el-pagination-hover-text-color: #ffd700;
  --el-pagination-active-text-color: #ffd700;
}
:deep(.el-pagination button) {
  color: #fff;
  background: rgba(255,255,255,0.06);
  border-color: rgba(255,255,255,0.1);
}
:deep(.el-pagination button:hover) {
  color: #ffd700;
  background: rgba(255,215,0,0.1);
}
:deep(.el-pagination .el-pager li) {
  color: #fff;
  background: rgba(255,255,255,0.06);
  border-color: rgba(255,255,255,0.1);
}
:deep(.el-pagination .el-pager li.active) {
  color: #fff;
  background: #ffd700;
  border-color: #ffd700;
}
:deep(.el-pagination .el-pager li:hover:not(.active)) {
  color: #ffd700;
  background: rgba(255,215,0,0.1);
}

/* 弹窗：无边框 + 透明 + 右上角关闭 */
.modal-mask {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.85);
}
.modal-content {
  text-align: center;
  position: relative;
  background: #ffffff;
  width: 90%;
  max-width: 360px;
  border-radius: 25px;
  padding: 20px;
  border: none;
  box-shadow: none;
  animation: modalIn 0.4s ease;
}
@keyframes modalIn {
  from { transform: scale(0.9); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}
.modal-close-x {
  position: absolute;
  right: -10px;
  top: -10px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(0,0,0,0.5);
  color: #fff;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
}
.modal-image {
  width: 100%;
  border-radius: 18px;;
  display:block;
}
.modal-name {
  font-size: 28px;
  font-weight: bold;
  color: #fff;
  margin-bottom: 12px;
  text-align: center;
}
.modal-attrs {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-bottom: 16px;
}
.modal-content-text {
  font-size: 15px;
  color: #fff;
  line-height: 1.6;
  margin-bottom: 28px;
  text-align: center;
}
/* ========== 弹窗图片 titleId 1‑10 外发光 10套颜色 ========== */
.title-glow-1 {
  /* 1 浅天蓝 #7dd3fc */
  box-shadow: 0 0 14px 4px #7dd3fc, 0 0 30px 10px rgba(125, 211, 252, 0.42);
}
.title-glow-2 {
  /* 2 香芋紫 #a78bfa */
  box-shadow: 0 0 14px 4px #a78bfa, 0 0 30px 10px rgba(167, 139, 250, 0.42);
}
.title-glow-3 {
  /* 3 金黄 #facc15 */
  box-shadow: 0 0 14px 4px #facc15, 0 0 30px 10px rgba(250, 204, 21, 0.42);
}
.title-glow-4 {
  /* 4 活力橙 #fb923c */
  box-shadow: 0 0 14px 4px #fb923c, 0 0 30px 10px rgba(251, 146, 60, 0.42);
}
.title-glow-5 {
  /* 5 蜜桃粉 #f472b6 */
  box-shadow: 0 0 14px 4px #f472b6, 0 0 30px 10px rgba(244, 114, 182, 0.42);
}
.title-glow-6 {
  /* 6 薄荷绿 #34d399 */
  box-shadow: 0 0 14px 4px #34d399, 0 0 30px 10px rgba(52, 211, 153, 0.42);
}
.title-glow-7 {
  /* 7 草莓红 #f87171 */
  box-shadow: 0 0 14px 4px #f87171, 0 0 30px 10px rgba(248, 113, 113, 0.42);
}
.title-glow-8 {
  /* 8 青湖蓝 #22d3ee */
  box-shadow: 0 0 14px 4px #22d3ee, 0 0 30px 10px rgba(34, 211, 238, 0.42);
}
.title-glow-9 {
  /* 9 梦幻紫 #c084fc */
  box-shadow: 0 0 14px 4px #c084fc, 0 0 30px 10px rgba(192, 132, 252, 0.42);
}
.title-glow-10 {
  /*10 嫩草绿 #4ade80 */
  box-shadow: 0 0 14px 4px #4ade80, 0 0 30px 10px rgba(74, 222, 128, 0.42);
}
.coin-group {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0; /* 金币区域不会被压缩 */
}
.coin-group img {
  height: 32px;
  width: auto;
  display: block;
  animation: coinFloat 2s ease-in-out infinite;
  transform-origin: center center;
}
.shimmer-gold {
  -webkit-text-fill-color: transparent;
  background: linear-gradient(90deg, #d97706, #fcd34d, #f59e0b, #fcd34d, #d97706) 0 0 / 200%;
  -webkit-background-clip: text;
  background-clip: text;
  animation: 2.5s linear infinite shimmer;
}

@keyframes coinFloat {
  0% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-4px) rotate(8deg);
  }
  100% {
    transform: translateY(0) rotate(0deg);
  }
}
@keyframes shimmer {
  0% { background-position: 0%; }
  100% { background-position: 200%; }
}

/* ========= 响应式媒体查询（手机、平板） ========= */
/* 平板：小于1100px，卡片改成2列 */
@media (max-width: 1100px) {
  .card-grid {
    grid-template-columns: repeat(2, 197px);
    grid-auto-rows: 274px;
  }
  .title {
    font-size: 2.2rem;
  }
}

/* 手机：小于768px，卡片1列，缩小尺寸 */
@media (max-width: 768px) {
  .card-grid {
    grid-template-columns: repeat(2, 201px);
    grid-auto-rows: 280px;
  }
  .title {
    font-size: 1.6rem;
  }
  .modal-close-x {
    right: 4px;
    top: 4px;
  }
}

.card-img-wrap {
  position: relative;
  display: inline-block;
  overflow: hidden;
  border-radius: 18px;
}
/* 第一条细斜光 */
.card-img-wrap::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 16%;
  height: 100%;
  background: linear-gradient(
      120deg,
      transparent 0%,
      rgba(255, 255, 255, 0.85) 40%,
      rgba(255, 255, 255, 0.95) 50%,
      rgba(255, 255, 255, 0.85) 60%,
      transparent 100%
  );
  transform: skewX(-20deg);
  animation: winStripeMove 1.8s linear infinite;
  pointer-events: none;
  z-index: 2;
}

/* 扫光动画，和抽卡弹窗共用，只需要定义一次 */
@keyframes winStripeMove {
  0% {
    left: -50%;
  }
  100% {
    left: 120%;
  }
}

/* ========== 属性发光 prop-glow，根据 cardPreviewPropertyId ========== */
:deep(.prop-glow-1) {
  box-shadow: 0 0 8px 2px #7dd3fc, 0 0 20px 6px rgba(125, 211, 252, 0.3);
}
:deep(.prop-glow-2) {
  box-shadow: 0 0 8px 2px #a78bfa, 0 0 20px 6px rgba(167, 139, 250, 0.3);
}
:deep(.prop-glow-3) {
  box-shadow: 0 0 8px 2px #facc15, 0 0 20px 6px rgba(250, 204, 21, 0.3);
}
:deep(.prop-glow-4) {
  box-shadow: 0 0 8px 2px #fb923c, 0 0 20px 6px rgba(251, 146, 60, 0.3);
}
:deep(.prop-glow-5) {
  box-shadow: 0 0 8px 2px #f472b6, 0 0 20px 6px rgba(244, 114, 182, 0.3);
}
:deep(.prop-glow-6) {
  box-shadow: 0 0 8px 2px #34d399, 0 0 20px 6px rgba(52, 211, 153, 0.3);
}
:deep(.prop-glow-7) {
  box-shadow: 0 0 8px 2px #f87171, 0 0 20px 6px rgba(248, 113, 113, 0.3);
}
:deep(.prop-glow-8) {
  box-shadow: 0 0 8px 2px #22d3ee, 0 0 20px 6px rgba(34, 211, 238, 0.3);
}
:deep(.prop-glow-9) {
  box-shadow: 0 0 8px 2px #c084fc, 0 0 20px 6px rgba(192, 132, 252, 0.3);
}
:deep(.prop-glow-10) {
  box-shadow: 0 0 8px 2px #4ade80, 0 0 20px 6px rgba(74, 222, 128, 0.3);
}
/* titleId對應外發光 shadow，和tag顏色對應 */
.glow-1 { box-shadow: 0 0 22px 6px #7dd3fc; }
.glow-2 { box-shadow: 0 0 22px 6px #a78bfa; }
.glow-3 { box-shadow: 0 0 22px 6px #facc15; }
.glow-4 { box-shadow: 0 0 22px 6px #fb923c; }
.glow-5 { box-shadow: 0 0 22px 6px #f472b6; }
.glow-6 { box-shadow: 0 0 22px 6px #34d399; }
.glow-7 { box-shadow: 0 0 22px 6px #f87171; }
.glow-8 { box-shadow: 0 0 22px 6px #22d3ee; }
.glow-9 { box-shadow: 0 0 22px 6px #c084fc; }
.glow-10 { box-shadow: 0 0 22px 6px #4ade80; }

/* 卡通全屏背景 */
.page-wrap {
  min-height: 100vh;
  background-image: url("~@/assets/images/cartoon_living.png");
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  background-repeat: no-repeat;
  position: relative;
}
/* 暗色半透明蒙版，防止背景太亮看不清内容 */
.page-wrap::before {
  content: '';
  position: fixed;
  inset: 0;
  background: rgba(255, 248, 237,0.45);
  z-index: 0;
}
.gacha-container {
  position: relative;
  z-index: 1;
}
.lucky-gacha-btn {
  background: white;
  color: rgb(120, 98, 26);
  font-family: Nunito;
  border: 2px solid rgb(253, 230, 138);
}

.lucky-gacha-btn.active {
  background: rgb(28, 26, 46);
  color: white;
  font-family: Nunito;
  border: 2px solid rgb(28, 26, 46);
}
.coin-stat {
  text-align: left;
}
.stat-title {
  font-size:14px;
  color:#666;
}
.stat-num {
  font-size:24px;
  color:#facc15;
  font-family: Nunito;
  font-weight: 900;
}
.shimmer-gold {
  background: linear-gradient(90deg, #D97706, #FCD34D, #F59E0B, #FCD34D, #D97706);
  background-size: 200% auto;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: shimmer 2.5s linear infinite;
}
.pagination-container {
  display: flex;
  justify-content: center;
  padding: 18px 0 6px;
}

/* 覆盖 element 分页默认样式 */
.pagination-container ::v-deep .el-pagination {
  padding: 10px 18px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(12px);
  box-shadow: 0 6px 20px rgba(99, 102, 241, 0.15),
  inset 0 0 0 1px rgba(99, 102, 241, 0.12);
}

/* 页码按钮 */
.pagination-container ::v-deep .el-pager li {
  margin: 0 4px;
  width: 34px;
  height: 34px;
  line-height: 34px;
  border-radius: 10px;
  font-weight: 600;
  color: #475569;
  background: transparent;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.pagination-container ::v-deep .el-pager li:hover {
  color: #6366f1;
  background: rgba(99, 102, 241, 0.1);
  transform: translateY(-2px);
}

/* 当前页 —— 渐变 + 辉光 */
.pagination-container ::v-deep .el-pager li.active {
  color: #fff;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #d946ef 100%);
  box-shadow: 0 6px 16px rgba(139, 92, 246, 0.45);
  transform: scale(1.08);
}

/* 上一页 / 下一页箭头 */
.pagination-container ::v-deep .el-pagination .btn-prev,
.pagination-container ::v-deep .el-pagination .btn-next {
  width: 34px;
  height: 34px;
  line-height: 34px;
  border-radius: 10px;
  color: #6366f1;
  transition: all 0.25s ease;
}

.pagination-container ::v-deep .el-pagination .btn-prev:hover,
.pagination-container ::v-deep .el-pagination .btn-next:hover {
  color: #fff;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.4);
}

.pagination-container ::v-deep .el-pagination .btn-prev.disabled,
.pagination-container ::v-deep .el-pagination .btn-next.disabled {
  color: #cbd5e1;
  background: transparent;
  box-shadow: none;
}

/* 跳转输入框 */
.pagination-container ::v-deep .el-pagination .el-input__inner {
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  transition: all 0.25s ease;
}

.pagination-container ::v-deep .el-pagination .el-input__inner:focus {
  border-color: #8b5cf6;
  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.15);
}

/* 总数文字 */
.pagination-container ::v-deep .el-pagination__total {
  font-weight: 600;
  color: #64748b;
}
.pagination-container ::v-deep .el-pagination__total::before {
  content: "✨ ";
}
text-gray-500 {
  color: #6a7282;
}
.font-medium {
  --tw-font-weight: 500;
  font-weight: 500;
}
.text-xs {
  font-size: 12px;
  line-height: 12.33px;
}
.table-button {
  border: none;
  border-radius: 1.75rem;
  font-size: 1.2rem;
  line-height: 1.5rem;
  padding: 0.5rem 2rem;
  background: linear-gradient(135deg, rgb(245, 158, 11), rgb(217, 119, 6));
  color: white;
  font-family: Nunito;
  box-shadow: rgba(245, 158, 11, 0.4) 0px 4px 16px;
}
</style>